/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import AdvancedSearch from './modules/AdvancedSearch';
import Home from './modules/Home';
import PostDetail from './modules/PostDetail';
import AdvancedSearchResult from './modules/AdvancedSearchResult';
import Stores from './modules/Stores';
import User from './modules/User';
import Account from './modules/Account';
import MyProfileEdit from './modules/MyProfileEdit';
import Login from './modules/Login';
import CreatePost from './modules/CreatePost';
import PostEdit from './modules/PostEdit';
import Forgot from './modules/Forgot';
import Reset from './modules/Reset';

import {TOKEN, AUTH_USER_ID, FILTER_NAMES, LOCALE} from './constant';

const filterInitialValues = locale => {
  const res = {};
  for(let key in FILTER_NAMES) {
    res[key] = [];
  }
  if(locale === "en")
    res.selectCondtionOptions = [
      {text: 'Select a condition', value: null},
      {text: 'Brand new', value: 5},
      {text: 'Good', value: 4},
      {text: 'Usable', value: 3},
      {text: 'Requires fixing', value: 2},
      {text: 'Unusable', value: 1}
    ];
  else if(locale === "fi")
    res.selectCondtionOptions = [
      {text: 'Valitse kuntotaso', value: null},
      {text: 'Upouusi', value: 5},
      {text: 'Hyvä', value: 4},
      {text: 'Käyttökunnossa', value: 3},
      {text: 'Tarvitse korjausta', value: 2},
      {text: 'Ei käyttökelpoinen', value: 1}
    ];
  return res;
};

export default new Vuex.Store({
  modules: {
    Home,
    PostDetail,
    AdvancedSearch,
    AdvancedSearchResult,
    Stores,
    Account,
    MyProfileEdit,
    User,
    Login,
    CreatePost,
    PostEdit,
    Forgot,
    Reset
  },
  state: {
    token: localStorage.getItem(TOKEN) || '',
    authenticatedUserID: localStorage.getItem(AUTH_USER_ID) || '',
    authenticatedUser: null,
    selectedCity: 'City',
    filters: {
      en: filterInitialValues('en'),
      fi: filterInitialValues('fi')
    },
    locale: localStorage.getItem(LOCALE) || 'fi' //fi or en
  },
  getters: {
    isAuthenticated: state => !!(state.token && state.authenticatedUserID)
  },
  mutations: {
    [TOKEN] (state, token) {
      state.token = token;
      localStorage.setItem(TOKEN, token);
      Vue.axios.defaults.headers.common['Authorization'] = "Bearer "+token;
    },
    [AUTH_USER_ID] (state, id) {
      state.authenticatedUserID = id;
      localStorage.setItem(AUTH_USER_ID, id);
    },
    'LOGIN' (state, val) {
      state.token = val.token;
      localStorage.setItem(TOKEN, val.token);
      state.authenticatedUserID = val._id;
      localStorage.setItem(AUTH_USER_ID, val._id);
      delete val.token;
      state.authenticatedUser = val;
    },
    'LOGOUT' (state) {
      state.token = '';
      localStorage.setItem(TOKEN, '');
      state.authenticatedUserID = '';
      localStorage.setItem(AUTH_USER_ID, '');
      Vue.axios.defaults.headers.common['Authorization'] = null;
    },
    'AUTH_USER' (state, val) {
      state.authenticatedUser = val;
    },
    'FILTERS' (state, val) {
      //state.filters.en[val.name] 
      const en = [{ value: undefined, text: FILTER_NAMES[val.name].en }];
      //state.filters.fi[val.name] 
      const fi = [{ value: undefined, text: FILTER_NAMES[val.name].fi }];
    
      for(let i=0; i<val.response.length; i++) {
        en.push({value: val.response[i]._id, text: val.response[i].en});
        fi.push({value: val.response[i]._id, text: val.response[i].fi});
      }

      state.filters.en[val.name] = en;
      state.filters.fi[val.name] = fi;
    },
    'ADD_OTHER_MAKER_FILTER' (state, val) {
      state.filters.en.Maker.push({value: val._id, text: val.en});
      state.filters.fi.Maker.push({value: val._id, text: val.fi});
    },
    'LOCALE' (state, val) {
      state.locale = val;
      localStorage.setItem(LOCALE, val);
    },
    'SET_CITY' (state, val) {
      state.selectedCity = val;
    }
  },
  actions: {
    'FETCH_HEALTH' () {
      return new Promise((resolve, reject) => {
        axios.get(`/health`)
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
      });
    },
    'FETCH_AUTH_USER' ({commit, state}) {
      
      axios.get(`/user/${state.authenticatedUserID}`)
      .then(resp => {
        commit('AUTH_USER', resp.data.response);
        console.log(resp.data);
      })
      .catch(err => {
        commit('LOGOUT');
        console.log(err.response);
        window.location.href = "/login";
      });
    },
    'LOGOUT' ({commit}) {
      commit('LOGOUT');
      window.location.href = "/login";
    },
    'FETCH_FILTERS' ({commit, state}, name) {
      //console.log("filter quick search name", name);
      if(state.filters[state.locale.toLowerCase()][name].length > 0) return;

      axios.get(`/filter?name=${name}`)
      .then(resp => {
        //console.log("filter quick search name", name, ',', resp.data.response);
        commit('FILTERS', {name: name, response: resp.data.response});
      })
      .catch(err => {
        //console.log(err);
        commit('FILTERS', {name: name, response: []});
      });
    },
    'FETCH_SIGNED_URI' ({}, data) {
      return new Promise((resolve, reject) => {
        axios.get(`/sign-s3`, {params: data})
        .then(resp => {
          console.log(resp.data);
          resolve(resp);
        })
        .catch(err => {
          console.log("err", err);
          reject(err);
        });
      });
    },
    'UPLOAD_FILE' ({}, data) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', data.uri);
        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4){
            if(xhr.status === 200){
              console.log("xhr", xhr);
              resolve(xhr);
            }
            else{
              console.log("err xhr", xhr);
              reject(xhr);
            }
          }
        };
        xhr.send(data.file);
      });
    },
    'CREATE_OTHER_MAKER' ({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`/other/maker`, payload)
        .then(resp => {
          console.log(resp.data);
          commit('ADD_OTHER_MAKER_FILTER', resp.data.response);
          resolve(resp);
        })
        .catch(err => {
          console.log("err", err.response);
          reject(err);
        });
      });
    },
    'S3_DELETE' ({_}, query) {
      axios.delete(`/s3`, {params: query})
      .then(resp => {
        console.log("s3 file deleted", resp.data);
      })
      .catch(err => {
        console.log("s3 file delete error", err);
      })
    }
  }
})